import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { RootState } from '@app/store';

import { API_CONFIG } from './config';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: API_CONFIG.baseURL,
    timeout: API_CONFIG.timeout,

    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).user.token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),

  tagTypes: ['User', 'Question', 'Course', 'Progress'],

  endpoints: () => ({}),
});

export const { middleware } = baseApi;
